import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import tw, { styled } from "twin.macro"
import { Link } from "gatsby"
import MovingElement from "@elements/MovingElement"
import parse from "html-react-parser"

const Section = styled.section`
  ${tw`relative z-10 overflow-hidden bg-white py-c80 2xl:py-c145`}
`
const Wrapper = styled.div`
  ${tw`relative z-10 max-w-2xl lg:max-w-4xl xl:max-w-7xl px-offset md:px-offsetMd xl:px-24`}
`

const TextHighlight = styled.span`
  background-image: linear-gradient(to right, #0000ff, #0000ff);
  background-size: 100% 100%;
  background-position: 0 100%;
  background-repeat: no-repeat;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`

const WpAcfTextMessageModuleBlock = ({ moduleData }) => {
  const { acfTextMessage } = moduleData
  return (
    <Section>
      <MovingElement
        speed={0.25}
        direction={{ negative: "", axis: "y" }}
        content={`<-{}|`}
        className="absolute top-0 z-[-1] text-3xl sm:text-5xl font-black transition-all duration-500 ease-in-out arrow-symbol -right-20 md:right-0 2xl:right-10 font-firacode text-blue xl:text-6xl 3xl:text-112"
      />
      <Wrapper>
        {/* top message wrapper */}
        <div className="top-message-wrapper mb-c20">
          {acfTextMessage.topMessage && (
            <span className="text-black top-message font-ubuntu text-32 sm:text-43 pr-c10">
              {parse(acfTextMessage.topMessage)}
            </span>
          )}
        </div>
        {/* bottom message wrapper */}
        {acfTextMessage.bottomMessage && (
          <div className="bottom-message-wrapper">
            <TextHighlight className="font-bold text-white px-c10 py-c5 bottom-message font-ubuntu text-32 sm:text-43 !leading-normal">
              {parse(acfTextMessage.bottomMessage)}
            </TextHighlight>
          </div>
        )}
        {acfTextMessage.bottomLink && (
          <Link
            to={acfTextMessage.bottomLink.url}
            className="flex items-center gap-c10 mt-c20"
          >
            <span className="font-bold text-black text-16 font-firacode">{`|->`}</span>
            <span className="font-bold text-black text-16 font-ubuntu">
              {acfTextMessage.bottomLink.title}
            </span>
          </Link>
        )}
      </Wrapper>
    </Section>
  )
}

WpAcfTextMessageModuleBlock.propTypes = {
  moduleData: PropTypes.object,
}

WpAcfTextMessageModuleBlock.defaultProps = {
  moduleData: {},
}

export default WpAcfTextMessageModuleBlock
